/**
 * @returns The version defined in the package.json as string.
 */
export function getPackageVersion(): string {
  return process.env.PLAYER_LIBRARY_PACKAGE_VERSION || '';
}
